import * as React from 'react';

export default (): JSX.Element => (
  <details>
    <summary>使い方</summary>
    <div className="content">
      <p>
        1.｢サイズ｣の入力欄に餌にするルーンの魔力値を入力すると、そのルーンを強化に使った時に上昇する魔力値が表示されます。素材が強化元と同種か虫歯の時は｢同種｣にチェックを入れれば良いと思うよ。
      </p>
      <p className="notes">
        ※端数の処理の問題で誤差が出る場合がわりとあります。うっかり超えちゃっても責任はとれないから気を付けてね←
      </p>
      <p>
        2.｢サイズ｣と｢強化元魔力値｣の値を入力し、｢計算する｣ボタンを押すと強化元の魔力値に応じて30・33にもっとも近づく餌の組み合わせを検索します。
      </p>
      <p className="notes">
        ※やっぱり誤差が出るかもしれないので、強化してからずれてても責任はとれません。(・ω&lt;)ﾃﾍﾍﾟﾛ
      </p>
      <p className="notes">
        ※｢強化元｣の値が小さすぎたり、餌の入力数が多すぎると計算に時間がかかったりエラーになるかも(・ω&lt;)ﾃﾍﾍﾟﾛ
      </p>
      <p>
        3.｢入力値保存｣ボタンを押すと、入力してある餌の情報を保存します。保存した値は｢保存値読込｣ボタンで復元できます。
      </p>
      <p className="notes">
        ※読込ボタンを押すと現在入力してある内容は上書きされます。
      </p>
      <p>
        4.ルーン一覧のSSを選択して｢SSから読み込む｣ボタンを押すと、SSに映ってるルーンの魔力値を読み込めるよ。
      </p>
      <p className="notes">
        ※画像の解析に少し時間がかかるよ。気長に待ってね(&nbsp;˘ω˘&nbsp;)ｽﾔ
      </p>
      <p className="notes">
        ※解析が終わったら読み込んだ値が表示されるよ。うまく読み込めなかったやつは赤枠で表示されるから手動で入力し直してね。入力が終わったら｢読み込む｣ボタンを押すと、緑枠のやつを読み込むよ(｢・ω・)｢
      </p>
    </div>
  </details>
);